import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashAdminComponent } from './directory/dash-admin/dash-admin.component';
import { SigninComponent } from './signin/signin.component';
import { EquipeComponent} from './directory/users/equipe/equipe.component';
import { NewVisitComponent } from './directory/new-visit/new-visit.component';
import { VisitesComponent } from './directory/visites/visites.component';
import { VisiteComponent } from './directory/visite/visite.component';
import { DashCommercialComponent } from './dash-commercial/dash-commercial.component';
import { PlanifierComponent } from './planifier/planifier.component';
import { DeplacementComponent } from './deplacement/deplacement.component';
import { ProfilComponent } from './profil/profil.component';
import { CustomersComponent } from './customers/customers.component';
import { ActionsComponent } from './actions/actions.component';
import { ConfigComponent } from './config/config.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ReferentialComponent } from './directory/referential/referential.component';
import { HasRoleGuard } from './rest_services/has-role.guard';
import { MyCustomersComponent } from './my-customers/my-customers.component';
import { UsersComponent } from './directory/users/users.component';
import { StatisticsComponent } from './directory/statistics/statistics.component';
import { CoverPageComponent } from './cover-page/cover-page.component';
import { StatisticsCustomersComponent } from './directory/statistics-customers/statistics-customers.component';
import { AdminSpaceComponent } from './admin-space/admin-space.component';
import { NewCustomerComponent } from './directory/new-customer/new-customer.component';
import { EditCustomerComponent } from './directory/edit-customer/edit-customer.component';
import { CustomerComponent } from './directory/customer/customer.component';
import { NewProfilComponent } from './directory/new-profil/new-profil.component';
import { ContactComponent } from './contact/contact.component';
import { NewContactComponent } from './directory/new-contact/new-contact.component';
import { FicheContactComponent } from './directory/fiche-contact/fiche-contact.component';
import { EditContactComponent } from './directory/edit-contact/edit-contact.component';
import { AbsenceComponent } from './absence/absence.component';
import { AbsenceRequestComponent } from './directory/absence-request/absence-request.component';
import { SupportComponent } from './support/support.component';
import { SupportReqComponent } from './directory/support-req/support-req.component';
import { CompleteVisitComponent } from './directory/complete-visit/complete-visit.component';
import { DashSupportComponent } from './dash-support/dash-support.component';
import { SatisfactionRequestComponent } from './surveys-list/surveys-list.component';
import { SurveyDetailComponent } from './directory/survey-detail/survey-detail.component';
import { SatisfactionSurveyComponent } from './satisfaction-survey/satisfaction-survey.component';
import { AbsenceUpdateComponent } from './directory/absence-update/absence-update.component';
import { AbsenceDetailComponent } from './directory/absence-detail/absence-detail.component';
import { MessagerieComponent } from './directory/messagerie/messagerie.component';
import { SupportTicketComponent } from './directory/support-ticket/support-ticket.component';
import { SupportDetailComponent } from './directory/support-detail/support-detail.component';
import { SupportSurveyComponent } from './directory/support-survey/support-survey.component';
import { ContactUsComponent } from './landingPage/contact-us/contact-us.component';
import { IndexComponent } from './landingPage/landing_index/index.component';
import { LandingMasterComponent } from './landingPage/landing_master/landing-master.component';
import { FunctionalitiesComponent } from './landingPage/functionalities/functionalities.component';
import { PublicPageGuard } from './guards/public-page.guard';
import { AuditComponent } from './audit/audit.component';
import { SalesComponent } from './sales/sales.component';
import { SalesCommercialComponent } from './sales-commercial/sales-commercial.component';
import { CustomersGoalsComponent } from './customers-goals/customers-goals.component';
import { CoverPageCaComponent } from './cover-page-ca/cover-page-ca.component';
import { WamCustomSurveyComponent } from './wam-custom-survey/wam-custom-survey.component';


const routes: Routes = [
  {path:'', 
    redirectTo:'index', 
    pathMatch:'full',
    canActivate:[PublicPageGuard] },
  {
    path: 'dashboard',
    component: DashAdminComponent,
    canActivate:[HasRoleGuard],
    data: {role:['adm']}
  },{
    path: 'dash',
    component: DashboardComponent,
    canActivate:[HasRoleGuard],
    data: {role:['asst']}
  },{
    path: 'mydash',
    component: DashCommercialComponent,
    canActivate:[HasRoleGuard],
    data: {role:['cmrc']}
  },
  {path: 'index',
    component: IndexComponent,
    children: [
      { path: '', component: LandingMasterComponent },
      { path: 'contact', component: ContactUsComponent },
      { path: 'functionalities', component: FunctionalitiesComponent }
    ],
    canActivate:[PublicPageGuard]},
  {
    path: 'contact' , 
    redirectTo:'index/contact',
    pathMatch:'full',
    canActivate:[PublicPageGuard]
  },
  {
    path: 'functionalities' , 
    redirectTo:'index/functionalities',
    pathMatch:'full',
    canActivate:[PublicPageGuard]
  },
  {
    path: 'signin' ,
    component: SigninComponent,
    canActivate:[PublicPageGuard]
  },
  {
    path: 'satisfaction-survey/:id' ,
    component: SatisfactionSurveyComponent,
    canActivate:[PublicPageGuard]
  },
  {
    path: 'wamgroup-satisfaction-survey/:id',
    component: WamCustomSurveyComponent,
    canActivate:[PublicPageGuard]
  },
  {
    path: 'support' ,
    component: SupportComponent,
    canActivate:[HasRoleGuard],
    data: {role:['adm','asst','cmrc']}
  },
  {
    path: 'support-req' ,
    component: SupportReqComponent,
    canActivate:[HasRoleGuard],
    data: {role:['adm','asst','cmrc']}
    
  },
  {
    path: 'dash-support' ,
    component: DashSupportComponent,
    canActivate:[HasRoleGuard],
    data: {role:['support']}
    
  },
  {
    path: 'tickets' ,
    component: SupportTicketComponent,
    canActivate:[HasRoleGuard],
    data: {role:['support']}
    
  },
  {
    path: 'support-survey' ,
    component: SupportSurveyComponent,
    canActivate:[HasRoleGuard],
    data: {role:['support']}
    
  },
  {
    path: 'ticket/detail/:id' ,
    component: SupportDetailComponent,
    canActivate:[HasRoleGuard],
    data: {role:['support','adm','asst','cmrc']}
  },
  {
    path: 'team' ,
    component: EquipeComponent,
    canActivate:[HasRoleGuard],
    data: {role:['adm']}
  },{
    path: 'newVisit',
    component: NewVisitComponent,
    canActivate:[HasRoleGuard],
    data: {role:['adm']}
  },{
    path: 'visites' ,
    component: VisitesComponent,
    canActivate:[HasRoleGuard],
    data: {role:['adm','asst']}
  },
  {
    path: 'deplacement' ,
    component: DeplacementComponent,
    canActivate:[HasRoleGuard],
    data: {role:['cmrc']}
  },
  {
    path: 'complete-visit/:name;cr=:id' ,
    component: CompleteVisitComponent,
    canActivate:[HasRoleGuard],
    data: {role:['cmrc']}
  },{
    path: 'profil' ,
    component: ProfilComponent,
    canActivate:[HasRoleGuard],
    data: {role:['adm','asst','cmrc']}
  },
  {
    path: 'visite/detail/:name;cr=:id' ,
    component: VisiteComponent,
    canActivate:[HasRoleGuard],
    data: {role:['adm','asst','cmrc']}

  },{
    path: 'visite/google/:cr',
    component: VisiteComponent,
    canActivate: [HasRoleGuard],
    data: { role: ['adm', 'asst', 'cmrc'] }
  },{
    path: 'planifier' ,
    component: PlanifierComponent,
    canActivate:[HasRoleGuard],
    data: {role:['cmrc']}
  },{
    path: 'customers/:name;cs=:id' ,
    component: CustomersComponent,
    canActivate:[HasRoleGuard],
    data: {role:['adm','asst']}
  },{
    path: 'my-customers/:name;cs=:id' ,
    component: MyCustomersComponent,
    canActivate:[HasRoleGuard],
    data: {role:['cmrc']}
  },{
    path: 'actions' ,
    component: ActionsComponent,
    canActivate:[HasRoleGuard],
    data: {role:['adm','cmrc','asst']}
  },{
    path: 'absence' ,
    component: AbsenceComponent,
    canActivate:[HasRoleGuard],
    data: {role:['adm','cmrc','asst']}
  },{
    path: 'absence-req' ,
    component: AbsenceRequestComponent,
    canActivate:[HasRoleGuard],
    data: {role:['adm','cmrc','asst']}
  },{
    path: 'absence-update/:id',
    component: AbsenceUpdateComponent,
    canActivate:[HasRoleGuard],
    data: {role:['adm','cmrc','asst']}
  },{
    path: 'absence-detail/:id',
    component: AbsenceDetailComponent,
    canActivate:[HasRoleGuard],
    data: {role:['adm','cmrc','asst']}
  },{
    path: 'referential' ,
    component: ReferentialComponent,
    canActivate:[HasRoleGuard],
    data: {role:['adm']}
  },{
    path: 'configuration' ,
    component: ConfigComponent,
    canActivate:[HasRoleGuard],
    data: {role:['adm']}
  },
  {
    path: 'users/:name;cs=:id' ,
    component: UsersComponent,
    canActivate:[HasRoleGuard],
    data: {role:['adm']}
  },{
    path: 'surveys-list' ,
    component: SatisfactionRequestComponent,
    canActivate:[HasRoleGuard],
    data: {role:['adm']}
  },{
    path: 'survey-detail/:id' ,
    component: SurveyDetailComponent,
    canActivate:[HasRoleGuard],
    data: {role:['adm']}
  },
  {
    path: 'statistics' ,
    component: StatisticsComponent,
    canActivate:[HasRoleGuard],
    data: {role:['adm','asst']}
  },
  {
    path: 'statistics_customers' ,
    component: StatisticsCustomersComponent,
    canActivate:[HasRoleGuard],
    data: {role:['adm','asst']}
  },
  {
    path: 'cover' ,
    component: CoverPageComponent,
    canActivate:[HasRoleGuard],
    data: {role:['adm','asst']}
  },
  {
    path: 'CAcover' ,
    component: CoverPageCaComponent,
    canActivate:[HasRoleGuard],
    data: {role:['adm','asst']}
  },
  {
    path: 'new-customer' ,
    component: NewCustomerComponent,
    canActivate:[HasRoleGuard],
    data: {role:['adm','cmrc','asst']}
  },
  {
    path: 'edit-customer/:uuid' ,
    component: EditCustomerComponent,
    canActivate:[HasRoleGuard],
    data: {role:['adm','cmrc','asst']}
  },
  {
    path: 'administration' ,
    component: AdminSpaceComponent,
    canActivate:[HasRoleGuard],
    data: {role:['adm-MF']}
  },
  {
    path: 'customer/:name;cs=:cs;vs=:vs' ,
    component: CustomerComponent,
    canActivate:[HasRoleGuard],
    data: {role:['adm','cmrc','asst']}
  },{
    path: 'addProfil' ,
    component: NewProfilComponent,
    canActivate:[HasRoleGuard],
    data: {role:['adm']}
  },
  {
    path: 'contacts' ,
    component: ContactComponent,
    canActivate:[HasRoleGuard],
    data: {role:['adm','cmrc','asst']}
  },
  {
    path: 'new-contact' ,
    component: NewContactComponent,
    canActivate:[HasRoleGuard],
    data: {role:['adm','cmrc','asst']}
  },
  {
    path: 'contact/:uuid' ,
    component: FicheContactComponent,
    canActivate:[HasRoleGuard],
    data: {role:['adm','cmrc','asst']}
  },
  {
    path: 'edit-contact/:uuid' ,
    component: EditContactComponent,
    canActivate:[HasRoleGuard],
    data: {role:['adm','cmrc','asst']}
  },{
    path: 'audit_traces',
    component: AuditComponent,
    canActivate:[HasRoleGuard],
    data: {role:['adm','asst']}
  },
  {
    path: 'messages/:detail;mb=:id' ,
    component: MessagerieComponent,
    canActivate:[HasRoleGuard],
    data: {role:['adm','cmrc','asst']}
  },{
    path: 'sales',
    component: SalesComponent,
    canActivate:[HasRoleGuard],
    data: {role:['adm','cmrc','asst']}
  },
  {
    path: 'sales/:name;cr=:id' ,
    component: SalesCommercialComponent,
    canActivate:[HasRoleGuard],
    data: {role:['adm','asst']}
  },
  {
    path: 'goals/:month;cm=:id' ,
    component: CustomersGoalsComponent,
    canActivate:[HasRoleGuard],
    data: {role:['adm','cmrc','asst']}
  },
  // { path: '**', redirectTo: '/index/', pathMatch:'full'},
  { path: '**', redirectTo: '/signin', pathMatch:'full'},
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
